import { useCallback, useRef, useState } from "react";

export const useDialog = (
  verifyErrorShouldTriggerDialog: (errorMessage: string) => boolean
): {
  reject: () => void;
  resolve: () => void;
  isOpen: boolean;
  payload: unknown;
  handleError: (errorCode: string) => Promise<unknown>;
} => {
  const resolveRef = useRef<unknown>(undefined);
  const rejectRef = useRef<unknown>(undefined);
  const [isOpen, setIsOpen] = useState(false);
  const [payload, setPayload] = useState<unknown>();

  const resolve = useCallback(() => {
    setIsOpen(false);

    if (resolveRef && typeof resolveRef.current === "function")
      resolveRef.current();
  }, []);

  const reject = useCallback(() => {
    setIsOpen(false);

    if (rejectRef && typeof rejectRef.current === "function")
      rejectRef.current();
  }, []);

  const handleError = useCallback(
    (errorCode: string, payload?: unknown) =>
      new Promise((resolve, reject) => {
        if (!verifyErrorShouldTriggerDialog(errorCode)) {
          reject(errorCode);

          return;
        }

        resolveRef.current = resolve;
        rejectRef.current = () => reject(errorCode);

        setIsOpen(true);
        setPayload(payload);
      }),
    [verifyErrorShouldTriggerDialog]
  );

  return {
    reject,
    resolve,
    isOpen,
    payload,
    handleError,
  };
};
